<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormPageBlogPost
          :data="blogPost"
          :blogCategories="blogCategories"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          :language="language"
          @submit="formBlogPostsSubmit"
          @delete-blog-post="deleteBlogPost"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmBlogPostRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormPageBlogPost from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import createBlogPost from '@/services/gql/types/BlogPosts/mutations/createBlogPost.gql'
import deleteBlogPost from '@/services/gql/types/BlogPosts/mutations/deleteBlogPost.gql'
import updateBlogPost from '@/services/gql/types/BlogPosts/mutations/updateBlogPost.gql'
import blogPostQuery from '@/services/gql/types/BlogPosts/queries/blogPost.gql'
import blogCategories from '@/services/gql/types/BlogCategory/queries/blogCategories.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'PageBlogPost',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    FormPageBlogPost,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать пост блога' : 'Создать пост блога'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      blogpost: null,
      blogCategories: null
    }
  },
  computed: {
    isMutationLoading () {
      return this.$async.createBlogPost.$pending || this.$async.updateBlogPost.$pending
    },
    isFormLoading () {
      return (
        this.$apollo.queries.blogPost.loading ||
        this.$apollo.queries.blogCategories.loading
      )
    }
  },
  methods: {
    async formBlogPostsSubmit (blockPostPayload) {
      // blockPostPayload.data.coverImageId = blockPostPayload.data.coverImage.id
      // delete blockPostPayload.data.coverImage
      if (!this.id) await this.createBlogPost(blockPostPayload)
      else await this.updateBlogPost(blockPostPayload)
    },
    async createBlogPost ({ data }) {
      delete data.translations
      try {
        await this.$async.createBlogPost.$perform({
          data
        })
        this.$successMsg('Пост блога создан')
        await this.$router.push({ name: 'page-blog-posts' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании блога поста')
      }
    },
    async deleteBlogPost () {
      try {
        await this.$refs.confirmBlogPostRemoving.open()
        await this.$async.deleteBlogPost.$perform({ id: Number(this.id) })
        this.$successMsg('Пост блога удален')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении блога поста с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-blog-posts' })
      }
    },
    async updateBlogPost ({ data }) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateBlogPost.$perform(
          {
            id: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Пост блога обновлен')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании поста блога')
      }
    }
  },
  apollo: {
    blogPost: {
      query: blogPostQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-blog-posts' })
        } else {
          this.blogPost = {
            ...res.data.blogPost,
            blogCategoryId: res.data?.blogPost?.blogCategory?.id
          }
        }
      }
    },
    blogCategories: {
      query: blogCategories,
      fetchPolicy: 'network-only',
      pollInterval: 30000,
      variables: {
        where: {}
      },
      result (res) {
        this.blogCategories = res?.data?.blogCategories.list
      }
    }
  },
  async: {
    createBlogPost (variables) {
      return this.$apollo.mutate({
        mutation: createBlogPost,
        variables
      })
    },
    deleteBlogPost (variables) {
      return this.$apollo.mutate({
        mutation: deleteBlogPost,
        variables
      })
    },
    updateBlogPost (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateBlogPost,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
